<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="handleSelectionChange"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10 ">
              <span class="span marginRight10 width80 textAlignRight"
                >网关ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >网关名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >场景 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.scenarioName"
                  placeholder="请输入场景名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >模型 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.modelName"
                  placeholder="请输入模型名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >分组/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建人 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.nickname"
                  placeholder="请输入创建人名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建人ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入创建人ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >网关地址 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.macAddr"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
            <el-button
              size="medium"
              type="warning"
              @click="handleBlacklist"
              class="marginLeft10"
              style="margin-bottom: 10px"
              :disabled="selectedRows.length === 0"
              >设置黑名单</el-button
            >
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="blackCount" slot-scope="{ row }">
        <span
          v-if="row.blackCount && row.blackCount !== '0'"
          class="clickable-count"
          @click="handleBlackCountClick(row)"
        >
          {{ row.blackCount }}
        </span>
        <span v-else class="non-clickable-count">{{ row.blackCount || 0 }}</span>
      </template>
    </avue-crud>

    <blacklist-dialog
      :visible.sync="blacklistDialogVisible"
      :selected-gateways="selectedRows"
      @success="handleBlacklistSuccess"
      @refresh="handleTableRefresh"
    />

    <blacklist-detail-drawer
      :visible.sync="blacklistDrawerVisible"
      :current-gateway="currentGateway"
      @refresh-table="onLoad"
      @update-black-count="handleUpdateBlackCount"
    />
  </div>
</template>

<script>
import { gatewayListModelRelateGateway } from "@/api/waveform/userScenario";
import { loadSetGatewayBlackList, loadGatewayElectricBlack } from "@/api/waveform/gateway";
import dayjs from "dayjs";
import BlacklistDialog from "./components/BlacklistDialog.vue";
import BlacklistDetailDrawer from "./components/BlacklistDetailDrawer.vue";

export default {
  name: "index",
  components: {
    BlacklistDialog,
    BlacklistDetailDrawer,
  },
  data() {
    return {
      searchData: {
        gatewayId: "",
        name: "",
        scenarioName: "",
        modelName: "",
        productType: "DFLRD",
        groupId: "",
        nickname: "",
        phone: "",
        createTime: null,
        macAddr: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      selectedRows: [],
      blacklistDialogVisible: false,
      blacklistDrawerVisible: false,
      currentGateway: {},
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        selection: true,
        reserveSelection: false,
        selectionFixed: false,
        tip: false,
        maxHeight:550,
        column: [
          {
            label: "ID",
            prop: "gatewayId",
          },
          {
            label: "网关地址",
            prop: "macAddr",
          },
          {
            label: "网关名称",
            prop: "name",
          },
          {
            label: "场景",
            prop: "scenarioName",
          },
          {
            label: "模型",
            prop: "modelName",
          },
          {
            label: "黑名单屏蔽数",
            prop: "blackCount",
            slot: true,
          },
          {
            label: "网关类型",
            prop: "productType",
          },
          {
            label: "归属分组",
            prop: "groupName",
          },
          {
            label: "创建人",
            prop: "nickname",
          },
          {
            label: "创建人手机",
            prop: "phone",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.bindTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.bindTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      
      // 使用新的接口 gatewayListModelRelateGateway
      gatewayListModelRelateGateway({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records || res.data.list || [];
          this.page.total = res.data.total;
        }
      }).catch((error) => {
        this.showLoading = false;
        console.error('加载网关列表失败:', error);
        this.$message.error('加载网关列表失败，请稍后重试');
      });
    },

    // 查询
    handleSearch() {
      this.page.currentPage = 1;
      this.blacklistDrawerVisible = false;
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        gatewayId: "",
        name: "",
        scenarioName: "",
        modelName: "",
        productType: "DFLRD",
        groupId: "",
        nickname: "",
        userId: "",
        phone: "",
        createTime: null,
        macAddr: "",
      };
      this.page.currentPage = 1;
      this.blacklistDrawerVisible = false;
      this.onLoad();
    },
    // 设置黑名单
    handleBlacklist() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择网关");
        return;
      }
      this.blacklistDialogVisible = true;
    },
    // 获取黑名单数据
    fetchBlacklistData() {
      this.blacklistLoading = true;
      waveformDictCode('cnnModeRecognitionType')
        .then((res) => {
          this.blacklistLoading = false;
          if (res.code === 200) {
            this.blacklistData = res.data || [];
          } else {
            this.$message.error('获取黑名单数据失败');
          }
        })
        .catch((error) => {
          this.blacklistLoading = false;
          console.error('获取黑名单数据失败:', error);
          this.$message.error('获取黑名单数据失败，请稍后重试');
        });
    },
    // 树形选择变化
    handleTreeCheck() {
      this.checkedBlacklistIds = this.$refs.blacklistTree.getCheckedKeys();
    },
    // 提交黑名单
    submitBlacklist() {
      const selectedBlacklist = this.$refs.blacklistTable.selection;
      if (selectedBlacklist.length === 0) {
        this.$message.warning('请先选择黑名单项');
        return;
      }
      
      // 构建请求数据
      const requestData = {
        gatewayIdList: this.selectedRows.map(row => row.id),
        dictItemIdList: selectedBlacklist.map(row => row.id)
      };
      
      console.log('提交的数据:', requestData);
      
      loadSetGatewayBlackList(requestData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('设置黑名单成功');
            this.blacklistDialogVisible = false;
            this.$refs.crud.clearSelection();
            this.selectedRows = [];
          } else {
            this.$message.error(res.msg || '设置黑名单失败');
          }
        })
        .catch((error) => {
          console.error('设置黑名单失败:', error);
        });
    },
    // 表格选择变化
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    // 黑名单设置成功回调
    handleBlacklistSuccess() {
      this.$refs.crud.clearSelection();
      this.selectedRows = [];
    },
    // 表格刷新回调
    handleTableRefresh() {
      this.onLoad();
    },
    // 黑名单屏蔽数点击处理
    handleBlackCountClick(row) {
      this.blacklistDrawerVisible = false;
      this.$nextTick(() => {
        this.currentGateway = row;
        this.blacklistDrawerVisible = true;
      });
    },
    // 更新黑名单屏蔽数
    handleUpdateBlackCount(data) {
      const gateway = this.tableData.find((item) => item.id === data.gatewayId);
      if (gateway) {
        gateway.blackCount = data.blackCount;
      }
    },
  },
};
</script>

<style scoped>
.content_top_right_user {
  width: 40px;
  height: 40px;
  margin-left: -20px;
  border-radius: 50%;
}
.content_top_right_user:first-of-type {
  margin-left: 0px;
}
.clickable-count {
  color: #00d8c3;
  cursor: pointer;
  font-size: 16px;
}
.clickable-count:hover {
  font-weight: 900;
  font-size: 18px;
}
.non-clickable-count {
  color: #606266;
  cursor: default;
  font-size: 16px;
}
</style>